export default __webpack_public_path__ + "static/media/hair-transplantation.76f38cad.pdf";